import { css } from 'styled-components';
import type { Brand } from '@/domainLogic/index.ts';
import { MODAL_THEME_VARIANTS } from '@/app/components/search/components/Modal/OpenXModal/types.ts';

const addDividerBetweenVerticalFilters = css`
  .container-item {
    &:after {
      content: '';
      display: block;
      width: 100%;
      height: 1px;
      background-color: ${({ theme }) => theme.kallisto.color.common.black[100]};
      margin-top: 16px;
    }

    &:last-child {
      &:after {
        content: none;
      }
    }
  }
`;

const whiteVariantPaddings = css`
  .container-controls {
    padding-left: 0;
    padding-right: 0;
  }
`;

export const variantStyles = css<{ brand: Brand; $variant?: MODAL_THEME_VARIANTS }>`
  ${({ $variant }) => {
    if ($variant === MODAL_THEME_VARIANTS.GRAY) {
      return css``;
    }

    if ($variant === MODAL_THEME_VARIANTS.WHITE) {
      return css`
        ${addDividerBetweenVerticalFilters};
        ${whiteVariantPaddings};
      `;
    }

    return css``;
  }};
`;
